/* eslint no-unused-vars: 0 */
/* eslint eqeqeq: 0 */
function getHandFreeSearchParams(handsFreeParams, attributes) {
  const {general, flavors, effects} = attributes;
  const filterParam = {};

  for (let i = 0; i < handsFreeParams.length; i++) {
    if (general.indexOf(handsFreeParams[i].key) !== -1) { // general
      const key = handsFreeParams[i].key;
      if (filterParam.generalAttrs) {
        filterParam.generalAttrs.push(key);
      } else {
        filterParam.generalAttrs = [key];
      }
    } else if (search(flavors, handsFreeParams[i].key) !== -1) { // flavors
      const key = handsFreeParams[i].key;
      if (filterParam.flavors) {
        filterParam.flavors.push(key);
      } else {
        filterParam.flavors = [key];
      }
    } else if (search(effects, handsFreeParams[i].key) !== -1) { // effects
      const key = handsFreeParams[i].key;
      if (filterParam.effects) {
        filterParam.effects.push(key);
      } else {
        filterParam.effects = [key];
      }
    } else { // search string
      const key = handsFreeParams[i].key;
      if (filterParam.productNames) {
        filterParam.productNames.push(key);
      } else {
        filterParam.productNames = [key];
      }
    }
  }
  return filterParam;
}

const search = (arr, val) => {
  for (let el of arr) {
      if (el === val) {
        return 1;
      }
  }
  return -1;
}

function getFilterParams(selectedAttributes) {
  const {handsFreeParams, selectedPriceRange, selectedCategories, selectedClassifications} = selectedAttributes;
  const result = {};

  if (selectedCategories.length > 0) {
    result.type = selectedCategories;
  }
    
  if (selectedClassifications.length > 0) {
    result.classifications = selectedClassifications;
  }

  if (selectedPriceRange.min > 0 || selectedPriceRange.max < 150) {
    const max = selectedPriceRange.max == 150 ? 1000 : selectedPriceRange.max;
    result.price = [selectedPriceRange.min, max];
  }

  if ('brand' in handsFreeParams) { result.brand = handsFreeParams.brand; }

  if ('generalAttrs' in handsFreeParams) { result.generalAttrs = handsFreeParams.generalAttrs; }

  if ('productNames' in handsFreeParams) { result.productNames = handsFreeParams.productNames; }
    
  // if ('subTypes' in handsFreeParams)
  //     result['subTypes'] = handsFreeParams.subTypes;
    
  if ('effects' in handsFreeParams) { result.effects = handsFreeParams.effects; }
    
  if ('flavors' in handsFreeParams) { result.flavors = handsFreeParams.flavors; }
    
  return result;
}

/* map hands free result to effects and attributes */
function mapAttributes(handsFreeValues, props) {
  const {effects} = props;
  const result = {attributes: [], effects: []};
  for (let i = 0; i < handsFreeValues.length; i++) {
    const key = handsFreeValues[i].key;
    if (search(effects, handsFreeValues[i].key) !== -1) {
      if (result.effects) {
        result.effects.push(key);
      } else {
        result.effects = [key];
      }
    } else if (result.attributes) {
      result.attributes.push(key);
    } else {
      result.attributes = [key];
    }
  }
  return result;
}

export {getHandFreeSearchParams, getFilterParams, mapAttributes, search};



// WEBPACK FOOTER //
// ./src/components/FilterBar/utils.js